/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/spinner/css/definition/content/spinner.css */
@layer spinner.definition.content.spinner {
  .spinner {
    display: inline-flex;
    align-items: center;
    vertical-align: var(--spinner-vertical-align);
    gap: var(--spinner-text-gap);
    contain: layout style paint;
  }
  .circle {
    --spinner-arc-stroke: calc(var(--spinner-size) * var(--spinner-arc-thickness));
    --spinner-arc-gap: calc(360deg - var(--spinner-arc));
    width: var(--spinner-size);
    height: var(--spinner-size);
    border-radius: 50%;
    flex-shrink: 0;
    contain: strict;
    will-change: transform;
    background:
      conic-gradient(
        from calc(var(--spinner-arc-gap) / 2),
        transparent 0deg,
        var(--spinner-color) var(--spinner-arc),
        transparent var(--spinner-arc));
    -webkit-mask:
      radial-gradient(
        farthest-side,
        transparent calc(100% - var(--spinner-arc-stroke) - 0.5px),
        #000 calc(100% - var(--spinner-arc-stroke)));
    mask:
      radial-gradient(
        farthest-side,
        transparent calc(100% - var(--spinner-arc-stroke) - 0.5px),
        #000 calc(100% - var(--spinner-arc-stroke)));
    animation: spin var(--spinner-speed) linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}

/* src/primitives/spinner/css/definition/content/text.css */
@layer spinner.definition.content.text {
  .spinner .text {
    font-size: var(--spinner-text-font-size);
    color: var(--spinner-text-color);
  }
  .spinner .circle + .text {
    margin-left: var(--gap-xs);
  }
}

/* src/primitives/spinner/css/definition/states/hidden.css */
@layer spinner.definition.states.hidden {
  .hidden.spinner:not(.active) {
    display: none;
  }
}

/* src/primitives/spinner/css/definition/states/active.css */
@layer spinner.definition.states.active {
  .active.spinner {
    display: inline-flex;
  }
}

/* src/primitives/spinner/css/definition/variations/colored.css */
@layer spinner.definition.variations.colored {
  .red.spinner {
    --spinner-color: var(--red);
  }
  .orange.spinner {
    --spinner-color: var(--orange);
  }
  .yellow.spinner {
    --spinner-color: var(--yellow);
  }
  .olive.spinner {
    --spinner-color: var(--olive);
  }
  .green.spinner {
    --spinner-color: var(--green);
  }
  .teal.spinner {
    --spinner-color: var(--teal);
  }
  .blue.spinner {
    --spinner-color: var(--blue);
  }
  .violet.spinner {
    --spinner-color: var(--violet);
  }
  .purple.spinner {
    --spinner-color: var(--purple);
  }
  .pink.spinner {
    --spinner-color: var(--pink);
  }
  .brown.spinner {
    --spinner-color: var(--brown);
  }
  .grey.spinner {
    --spinner-color: var(--grey);
  }
  .slate.spinner {
    --spinner-color: var(--slate);
  }
}

/* src/primitives/spinner/css/definition/variations/block.css */
@layer spinner.definition.variations.block {
  .block.spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-inline: auto;
    gap: var(--spinner-block-text-gap);
    --spinner-size: var(--spinner-block-size);
    --spinner-arc-thickness: var(--spinner-block-arc-thickness);
    --spinner-speed: var(--spinner-block-speed);
  }
}

/* src/primitives/spinner/css/definition/variations/overlay.css */
@layer spinner.definition.variations.overlay {
  .overlay.spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    inset: 0;
    width: fit-content;
    height: fit-content;
    margin: auto;
    gap: var(--spinner-overlay-text-gap);
    --spinner-size: var(--spinner-overlay-size);
    --spinner-arc-thickness: var(--spinner-overlay-arc-thickness);
    --spinner-speed: var(--spinner-overlay-speed);
  }
}

/* src/primitives/spinner/css/definition/variations/sizing.css */
@layer spinner.definition.variations.sizing {
  .mini.spinner {
    --spinner-size: var(--spinner-mini-size);
  }
  .tiny.spinner {
    --spinner-size: var(--spinner-tiny-size);
  }
  .small.spinner {
    --spinner-size: var(--spinner-small-size);
  }
  .large.spinner {
    --spinner-size: var(--spinner-large-size);
  }
  .big.spinner {
    --spinner-size: var(--spinner-big-size);
  }
  .huge.spinner {
    --spinner-size: var(--spinner-huge-size);
  }
  .massive.spinner {
    --spinner-size: var(--spinner-massive-size);
  }
}

/* src/primitives/spinner/css/definition/spinner-definition.css */

/* src/primitives/spinner/css/theme/content/spinner-variables.css */
@layer spinner.theme.content.spinner {
  :host {
    --spinner-size: 1em;
    --spinner-color: #2274b4;
    --spinner-arc-thickness: 0.12;
    --spinner-arc: 330deg;
    --spinner-speed: 0.7s;
    --spinner-vertical-align: -0.15em;
  }
}

/* src/primitives/spinner/css/theme/content/text-variables.css */
@layer spinner.theme.content.text {
  :host {
    --spinner-text-gap: var(--gap-2xs);
    --spinner-text-font-size: var(--relative-small);
    --spinner-text-color: var(--muted-text-color);
  }
}

/* src/primitives/spinner/css/theme/states/active-variables.css */
@layer spinner.theme.states.active {
  :host {
  }
}

/* src/primitives/spinner/css/theme/states/hidden-variables.css */
@layer spinner.theme.states.hidden {
  :host {
  }
}

/* src/primitives/spinner/css/theme/variations/colored-variables.css */
@layer spinner.theme.variations.colored {
  :host {
  }
}

/* src/primitives/spinner/css/theme/variations/block-variables.css */
@layer spinner.theme.variations.block {
  :host {
    --spinner-block-size: 64px;
    --spinner-block-arc-thickness: 0.09;
    --spinner-block-speed: 0.9s;
    --spinner-block-text-gap: var(--gap-s);
  }
}

/* src/primitives/spinner/css/theme/variations/overlay-variables.css */
@layer spinner.theme.variations.overlay {
  :host {
    --spinner-overlay-size: 64px;
    --spinner-overlay-arc-thickness: 0.09;
    --spinner-overlay-speed: 0.9s;
    --spinner-overlay-text-gap: var(--gap-s);
  }
}

/* src/primitives/spinner/css/theme/variations/sizing-variables.css */
@layer spinner.theme.variations.sizing {
  :host {
    --spinner-mini-size: 10px;
    --spinner-tiny-size: 11px;
    --spinner-small-size: 12px;
    --spinner-large-size: 16px;
    --spinner-big-size: 18px;
    --spinner-huge-size: 20px;
    --spinner-massive-size: 24px;
  }
}

/* src/primitives/spinner/css/theme/spinner-theme.css */

/* src/primitives/spinner/css/spinner.css */
